import React from "react";

/**
 * Consistent loading indicator used across the app.
 *
 * Variants:
 *  - "block": fills a section with vertical padding (default)
 *  - "page": full-screen centered (e.g. above-the-fold)
 *  - "inline": small inline indicator
 */
export default function Loading({ label = "Loading", variant = "block" }) {
  if (variant === "inline") {
    return (
      <span className="inline-flex items-center gap-2 text-xs uppercase tracking-widest text-slate-400">
        <Spinner size="sm" />
        {label}…
      </span>
    );
  }
  if (variant === "page") {
    return (
      <div className="min-h-[60vh] flex items-center justify-center">
        <div className="flex flex-col items-center gap-4">
          <Spinner size="lg" />
          <div className="text-xs uppercase tracking-[0.3em] text-slate-400 animate-pulse">{label}…</div>
        </div>
      </div>
    );
  }
  // block (default)
  return (
    <div className="text-center py-20">
      <div className="inline-flex flex-col items-center gap-3">
        <Spinner size="md" />
        <div className="text-xs uppercase tracking-[0.3em] text-slate-400 animate-pulse">{label}…</div>
      </div>
    </div>
  );
}

function Spinner({ size = "md" }) {
  const dim = size === "sm" ? "w-3 h-3 border" : size === "lg" ? "w-12 h-12 border-2" : "w-6 h-6 border-2";
  return <div className={`${dim} rounded-full border-gold/20 border-t-gold animate-spin`} />;
}
